import { EntityStatusHighlightColors } from '@global-dax-ad-platform/dax-types';
import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { Box } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'components/StatusIndicator/StatusIndicator.styles';
import { DEFAULT_STATUS_INDICATOR_SIZE } from 'utils/defaults';
import { colorMapping } from 'utils/statuses';

type StatusIndicatorProps = {
  color: EntityStatusHighlightColors;
  size?: string;
};

const StatusIndicator = ({ color, size = DEFAULT_STATUS_INDICATOR_SIZE }: StatusIndicatorProps) => {
  const mappedColor = colorMapping[color] ?? theme.palette.primary.main;
  const classes = useStyles({ statusColour: mappedColor, statusSize: size });

  return <Box className={classes.root} data-testid="status-indicator" />;
};

export default StatusIndicator;
